import React from "react";
import styles from "../CTA.module.scss";
import { BoxOptionsType, CTAModuleType } from "../CTA";
import { Headline } from "@/components/Headline/Headline";
import { useSublinesVisibility } from "@/hooks/useSublinesOverlinesVisibility";
import { ContentTag } from "@/components/ContentTag/ContentTag";
import { ExtendedLink } from "@/components/ExtededLink/ExtendedLink";
import { Button } from "@/components/Button/Button";
import { getItemAttributes } from "@/components/_primitives/utils/getItemAttributes";
import { getBoxPaddingVars } from "@/utils/getResponsiveCssVars";
function CTAText({
  data,
  show_overline_subline,
  show_extended_link,
  button_type,
  box,
  columns_text,
  type,
}: {
  data: CTAModuleType;
  show_overline_subline: "overline" | "subline" | "none";
  show_extended_link: boolean;
  button_type: "primary" | "secondary";
  box: BoxOptionsType;
  columns_text?: Record<string, string>;
  type: "text-image" | "text-only";
}) {
  const { text_align_class, background_color_class, module_width } =
    data.layout;
  const {
    headline,
    content,
    link,
    overline,
    subline,
    headline_html_tag,
    link_extended,
  } = data.cta;
  const { show_card_box, show_box_shadow, show_border_radius, box_padding } =
    box;
  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline,
  );
  const attr = getItemAttributes({
    itemWidth: columns_text,
    // className: ``,
    itemAttrFor: "cta",
  });
  return (
    <div
      style={{
        ...attr.style,
        ...(getBoxPaddingVars(box_padding ?? null) as React.CSSProperties),
      }}
      className={[
        "is-flex is-flex-direction-column is-justify-content-center",
        text_align_class,
        type === "text-image"
          ? background_color_class
          : `column ${columns_text}`,
        styles["cta-text"],
        show_card_box && show_box_shadow ? "has-box-shadow" : "",
        show_card_box && show_border_radius ? "has-border-radius" : "",
        type === "text-only" ? attr.className : "",
      ].join(" ")}
    >
      <Headline
        headline_html_tag={headline_html_tag}
        headline={headline}
        overline={showOverline ? overline : ""}
        subline={showSubline ? subline : ""}
        extraClass={text_align_class}
        wrapInSection={module_width === "frameless"}
        disableAnimation
      />
      {content && <ContentTag content={content} />}
      {show_extended_link && link_extended && (
        <ExtendedLink extendedLink={link_extended} btnType={button_type} />
      )}
      {!show_extended_link && link && link.url && (
        <Button
          type={button_type}
          href={link.url}
          target={link.target}
          aria-label={link.aria_label}
          className={`${text_align_class === "has-text-centered" ? "mx-auto" : ""}`}
        >
          {link.title}
        </Button>
      )}
    </div>
  );
}

export default CTAText;
